const GRAPH_HOST = "graph.microsoft.com";

/**
 * True when `url` targets one of our own backends — either same-origin as the
 * running app, or matching a configured API base — and is NOT Microsoft Graph
 * (which the separate MsalInterceptor handles).
 */
export function isOurBackendUrl(url: string, bases: string[], pageOrigin: string): boolean {
  let host = "";
  let sameOrigin = false;
  try {
    const parsed = new URL(url, pageOrigin);
    host = parsed.host;
    sameOrigin = parsed.origin === pageOrigin;
  } catch {
    return false;
  }

  if (host === GRAPH_HOST) {
    return false;
  }
  if (sameOrigin) {
    return true;
  }
  return bases.filter(Boolean)
.some((base) => url.startsWith(base));
}
